var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-display"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"title col-sm-6"},[_c('span',[_vm._v(_vm._s(this.$t(("app.sites.attributes." + _vm.title))))])]),_vm._v(" "),_c('div',{staticClass:"value col-sm-6"},[_c('span',[_vm._v(_vm._s(_vm.value ? _vm.value : this.$t("app.partners.missing")))])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15ee826e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/partners/CardDisplay.vue
// module id = null
// module chunks = 